import React from "react";
import { Button, FormControlLabel, Switch } from "@mui/material";
import MerchantStoreList from "../../../../components/MerchantStoreList";
import { COLORS } from "../../../../utils/colors";
import EmptyState from "../../../EmptyStates/EmptyState";

const MerchantStores = ({
  merchant,
  merchantStores,
  setModalTitle,
  setModalContent,
  handleDisplayModal,
  includeInactiveStores,
  setIncludeInactiveStores,
}) => {
  const AddMerchantStore = () => (
    <Button
      sx={{ backgroundColor: COLORS.priorityBlue.hex }}
      variant="contained"
      onClick={() => {
        setModalTitle("Add Merchant Store");
        setModalContent("addMerchantStore");
        handleDisplayModal(true);
      }}
    >
      Add New Store
    </Button>
  );

  return (
    <div className="mt-4 flex flex-column gap-4">
      <div className="flex flex-row flex-wrap w-full items-center justify-between gap-4">
        <AddMerchantStore />
        <FormControlLabel
          control={
            <Switch
              checked={includeInactiveStores}
              onChange={(e) => setIncludeInactiveStores(e.target.checked)}
              color="primary"
            />
          }
          label="Show all stores (including deleted)"
        />
      </div>
      {!merchantStores?.length ? (
        <div className="w-full flex justify-center py-8">
          <EmptyState
            type="merchantStores"
            text={
              includeInactiveStores
                ? "No merchant stores for this account."
                : "No active stores. Use the toggle above to include deleted locations."
            }
            action={<AddMerchantStore />}
          />
        </div>
      ) : (
        <MerchantStoreList storeList={merchantStores} merchant={merchant} />
      )}
    </div>
  );
};

export default MerchantStores;
